import { GetterTree } from 'vuex';
import { IRootState } from './types';

export const rootGetters: GetterTree<IRootState, {}> = {
};
